export const UPDATE = 'Update'
export const GET = 'Get'
export const GET_BY_ID = 'Get by id'
export const ADD_AFFILIATE = 'Add affiliate'
export const REMOVE_AFFILIATE = 'Remove affiliate'
export const GET_ALL = 'Get all'
export const SET = 'Set'
export const CREATE = 'Create'
export const GET_FOR_APP = 'Get for app'
export const GET_FOR_MAINTAINER = 'Get for maintainer'
export const GET_FOR_FLOW = 'Get for flow'
export const GET_BY_NAME = 'Get by name'
export const DELETE = 'Delete'
export const REGISTER_TASK = 'Register task'

export default {
  UPDATE,
  GET,
  GET_BY_ID,
  GET_FOR_APP,
  GET_FOR_MAINTAINER,
  GET_FOR_FLOW,
  GET_BY_NAME,
  ADD_AFFILIATE,
  REMOVE_AFFILIATE,
  GET_ALL,
  CREATE,
  DELETE,
  REGISTER_TASK
}
